import { tokens } from '@welbe/web-design-system'
import styled from 'styled-components'

export const Container = styled.div`
	height: auto;
	display: flex;
	flex-direction: column;
	gap: 24px;
	margin: 0 auto;
	max-width: 672px;
	padding: 20px 20px 40px 20px;

	& > svg {
		align-self: center;
	}

	p {
		align-items: flex-start;
		font-size: 14px;
		font-weight: 500;
		line-height: 24px;
	}

	a {
		font-size: 14px;
		font-weight: 600;
		color: ${tokens.color_primary};
	}
`
